var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"custom-display-element-details"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"section"},[_c('custom-display-element-versions',{attrs:{"id":"widget-versions"}})],1),_c('div',{staticClass:"section"},[_c('custom-display-element-translations',{attrs:{"id":"widget-translations"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }